<textarea
  rows="3"
  [placeholder]="field.placeholder"
  [formControl]="control"
></textarea>
